import React from "react";
import { usePalette } from "react-palette";
import { hexToRgb } from "../utils/Helpers";

//This is implemented to reduce the redundant code.
const mappingArray = [
  "vibrant",
  "lightVibrant",
  "darkVibrant",
  "muted",
  "lightMuted",
  "darkMuted",
];

const ColorCard = ({ image }) => {
  const { data } = usePalette(image);
  return (
    <div className="col-sm-6">
      <div className="card card-wrapper">
        <img src={image} alt={image} className="card-img-top grid-image" />
        <div className="color-grid">
          {mappingArray.map((mappedName, i) => {
            return (
              <div key = {i}>
                <div
                  className="color-palette"
                  style={{ backgroundColor: data[mappedName] }}
                />
                <div className="color-value">{data[mappedName]}</div>
                <div className="color-value">{hexToRgb(data[mappedName])}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ColorCard;
